/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PackageModuleApi } from '../api/packageModule.api';
import { switchMap, map } from 'rxjs/operators';
import { PackageModuleData, PackageModule } from '../../../interfaces/masters/packagemodule';

@Injectable()
export class PackageModuleService extends PackageModuleData {

  constructor(private api: PackageModuleApi) {
    super();
  }


  list(): Observable<PackageModule[]> {
    return this.api.list();
  }
  moduleList(url: string): Observable<PackageModule[]> {
    return this.api.moduleList(url);
  }
  
  getById(url: string): Observable<PackageModule>{
      return this.api.getById(url);
  }

  create(url: string, data: PackageModule): Observable<PackageModule> {
    return this.api.add(url,data);
  }

  update(url: string, data: PackageModule): Observable<PackageModule> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
